const setQueue = (state, queue) => {
  Object.assign(state, { queue })
  if (queue) {
    Object.assign(state, { updatedAt: new Date() })
  } else {
    Object.assign(state, { updatedAt: null })
  }
}
const setQueueListener = (state, listener) => {
  if (state.queueListener) {
    state.queueListener()
  }
  state.queueListener = listener
}

const clearQueueListener = state => {
  if (state.queueListener) {
    state.queueListener()
  }
  state.queueListener = null
}

export default {
  setQueue,
  setQueueListener,
  clearQueueListener
}
